import { BaseUrl } from "./AdditionalApi"

export const PostUrl = `${BaseUrl}/api/news/`;

export default PostUrl